import React from 'react';
import * as classes from './LatestContent.module.scss'
import MediaQuery from 'react-responsive';
import { getFileName } from '../../helpers/FileCatching';
import { trackCustomEvent } from "../../helpers/tracking";

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function LatestContent({content, GlobalData}) {

    function onPromoClick(title){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Click",
          label: "Content " + title
        }
        trackCustomEvent(trackObject);
    }

    let latestArticles = content.articles.map((item, index) => 
       
        <div key={index} className={classes.LatestContent__promoSlot}>
            <div className={classes.LatestContent__promoSlot__imageContainer}>
                <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}>
                    <img src={getFileName(contentImages,item.image).default} alt={item.imageAlt} className={classes.LatestContent__promoSlot__image}/>
                </a>
            </div>
            <MediaQuery maxWidth={classes.screenLgMax}>
                <div className={classes.LatestContent__promoSlot__textWrap}>
                    <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}><h3 className={`${classes.LatestContent__promoSlot__header} promoHeading`}>{item.heading}</h3></a>
                    <h2 className={`${classes.LatestContent__promoSlot__title} promoTitle`}>{item.title}</h2>
                    <a href={item.ctaURL} className={`${classes.LatestContent__promoSlot__cta} button`}><p>{content.ctaText}</p></a>
                </div>
            </MediaQuery>
            <MediaQuery minWidth={classes.screenLg}>
                <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}><h3 className={`${classes.LatestContent__promoSlot__header} promoHeading`}>{item.heading}</h3></a>
                <h2 className={`${classes.LatestContent__promoSlot__title} promoTitle`}>{item.title}</h2>
                <a href={item.ctaURL} className={`${classes.LatestContent__promoSlot__cta} button`}><p>{content.ctaText}</p></a>
            </MediaQuery>
        </div>
    )
    
    return (
        <div className={`${classes.LatestContent}`}>
            
            <div className={`${classes.LatestContent__maskBackground}`}>
                <img src={getFileName(contentImages,'Mask.png').default} alt={'Black curved background'}/>
            </div>      
            
            <div className={`${classes.LatestContent__wrapper}`}>
                <div className={classes.LatestContent__heroContainer}>
                    <div className={classes.LatestContent__heroSlot}>
                        <div className={classes.LatestContent__heroSlot__imageContainer}>
                            <a href={content.heroArticle.ctaURL} onClick={() => { onPromoClick(content.heroArticle.title) }}>
                                <MediaQuery maxWidth={classes.screenMdMax}>
                                    <img src={getFileName(contentImages,content.heroArticle.mobileImage).default} alt={content.heroArticle.imageAlt} className={classes.LatestContent__heroSlot__image}/>
                                </MediaQuery>
                                <MediaQuery minWidth={classes.screenMd}>
                                    <img src={getFileName(contentImages,content.heroArticle.desktopImage).default} alt={content.heroArticle.imageAlt} className={classes.LatestContent__heroSlot__image}/>
                                </MediaQuery>
                            </a>
                        </div>
                        <div className={classes.LatestContent__heroSlot__textWrap}>
                            <a href={content.heroArticle.ctaURL} onClick={() => { onPromoClick(content.heroArticle.title) }}><h3 className={`${classes.LatestContent__heroSlot__header} promoHeading`}>{content.heroArticle.heading}</h3></a>
                            <h2 className={`${classes.LatestContent__heroSlot__title} promoTitle`}>{content.heroArticle.title}</h2>
                            <a href={content.heroArticle.ctaURL} className={`${classes.LatestContent__heroSlot__cta} button`} onClick={() => { onPromoClick(content.heroArticle.title) }}><p>{content.ctaText}</p></a>
                        </div>
                    </div>
                </div>
                <div className={classes.LatestContent__promoSlotContainer}>
                    {latestArticles}
                </div>

            </div>
        </div>
    );
}

export default LatestContent;